import { render, staticRenderFns } from "./CertificationSuccess.vue?vue&type=template&id=21b5512f"
import script from "./CertificationSuccess.vue?vue&type=script&lang=js"
export * from "./CertificationSuccess.vue?vue&type=script&lang=js"
import style0 from "./CertificationSuccess.vue?vue&type=style&index=0&id=21b5512f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports